module.exports = __webpack_public_path__ + "img/arbre_4_ombre.4107db1e.png";